import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { LOGOUT_CUSTOMER_360, LOGOUT_CUSTOMER_360_SUCCESS, LOGOUT_CUSTOMER_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* logoutCustomer360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.urlParams;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/end-customer-session`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: LOGOUT_CUSTOMER_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LOGOUT_CUSTOMER_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LOGOUT_CUSTOMER_360_ERROR, payload: error });
  }
}

export function* watchlogoutCustomer360() {
  yield takeEvery(LOGOUT_CUSTOMER_360, logoutCustomer360);
}

function* logoutCustomer360Saga() {
  yield all([fork(watchlogoutCustomer360)]);
}

export default logoutCustomer360Saga;
